// Routines
export const CREATE_PARTNERSHIP_MEMBER = 'CREATE_PARTNERSHIP_MEMBER';
export const FETCH_PARTNERSHIP_MEMBERS = 'FETCH_PARTNERSHIP_MEMBERS';
export const FETCH_SINGLE_PARTNERSHIP_MEMBER = 'FETCH_SINGLE_PARTNERSHIP_MEMBER';
export const UPDATE_PARTNERSHIP_MEMBER = 'UPDATE_PARTNERSHIP_MEMBER';

export const REMOVE_FORM_PARTNERSHIP_MEMBER = 'REMOVE_FORM_PARTNERSHIP_MEMBER';
export const SET_FORM_PARTNERSHIP_MEMBERS = 'SET_FORM_PARTNERSHIP_MEMBERS';
